@if (formGroup) {
  <app-select-input
    [controlName]="controlName"
    [controlLabel]="controlLabel"
    [formGroup]="formGroup"
    [options]="projects"
    [id]="id"
    optionValueKey="projectName"
    [showAllOption]="showAllOption"
    (selectionChange)="onSelectionChanged($event)"
    (openedChange)="onOpenedChanged($event)">
  </app-select-input>
}

@if (!formGroup) {
  <app-select-input
    [controlName]="controlName"
    [controlLabel]="controlLabel"
    [(model)]="model"
    [options]="projects"
    [id]="id"
    optionValueKey="projectName"
    [showAllOption]="showAllOption"
    (selectionChange)="onSelectionChanged($event)"
    (openedChange)="onOpenedChanged($event)">
  </app-select-input>
}
